import CacheEnabledApiClient from '../CacheEnabledApiClient';

export class LeadDistributionsAPI extends CacheEnabledApiClient {
  constructor() {
    super('lead_distributions', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'leadDistribution';
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }
}

export default new LeadDistributionsAPI();
